// extracted by mini-css-extract-plugin
export default {"enrichment_html":"enrichment-html_enrichment_html__B5k-L"};